import { render, staticRenderFns } from "./PayBalanceBack.vue?vue&type=template&id=4cebd1f9"
import script from "./PayBalanceBack.vue?vue&type=script&lang=js"
export * from "./PayBalanceBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports